import React, { useContext } from 'react';
import { Modal } from 'semantic-ui-react';
import { createStructuredSelector } from 'reselect';
import { connect } from 'react-redux';

import { AppState } from 'services/types';
import { updateQueryString as updateQueryStringAction } from 'services/router/actions';
import {
    makeSelectQueryStringValue
    // @ts-ignore
} from 'workspaces/react-router-selectors';

import { VirtualizedTableContextProviderValue } from '../../types';
import VirtualizedTableCreateFormWrapper from '../VirtualizedTableCreateFormWrapper';
import VirtualizedTableContext from '../VirtualizedTableContext';
import { CREATE_MODAL_QUERY_STRING_PARAM } from '../../constants';

interface ConnectedProps {
    queryStringValue: ReturnType<ReturnType<typeof makeSelectQueryStringValue>>;
}

interface DispatchProps {
    updateQueryString: typeof updateQueryStringAction;
}

type Props = ConnectedProps & DispatchProps;

export const VirtualizedTableCreateModalComponent = (
    props: Props
): React.ReactElement => {
    const {
        label,
        modalSize = 'fullscreen'
    }: VirtualizedTableContextProviderValue = useContext(
        VirtualizedTableContext
    );
    const { queryStringValue } = props;

    const handleClose = (): void => {
        props.updateQueryString({
            [CREATE_MODAL_QUERY_STRING_PARAM]: undefined
        });
    };
    const className =
        modalSize === 'fullscreen' ? 'constrain-width' : undefined;

    return (
        <Modal
            size={modalSize}
            open={!!queryStringValue}
            centered={false}
            onClose={handleClose}
            closeIcon
        >
            <React.Fragment>
                <Modal.Header>Create{label ? ` ${label}` : ''}</Modal.Header>
                <Modal.Content className={className}>
                    <VirtualizedTableCreateFormWrapper />
                </Modal.Content>
            </React.Fragment>
        </Modal>
    );
};

const mapStateToProps = createStructuredSelector<AppState, {}, ConnectedProps>({
    queryStringValue: makeSelectQueryStringValue(
        CREATE_MODAL_QUERY_STRING_PARAM
    )
});

export default connect(mapStateToProps, {
    updateQueryString: updateQueryStringAction
})(VirtualizedTableCreateModalComponent);
